// @flow

import React, { type Node } from 'react';
import {
  getSafeSpeiUrl,
  getDestinyBank,
  usePendingIncomingPayment,
  redirectIfCheckForConfirmationIsEnabled,
} from '@tectonics/prs/incoming-payment';
import { ButtonWrapper, LinkButton } from '../commons/render-helpers';
import styled from 'styled-components';
import {CopyToClipboardIcon, useCopyToClipboard} from '../../../../uber/commons/molecules';
import {useScreenWidth} from '../../../../../hooks';

export function RenderPaymentInstructions(): Node {
  return (
    <InfoBoxWrapper>
      <InfoBoxColumn>
        <CirclesWrapper>
          <Circle>1</Circle>
          <Circle>2</Circle>
          <Circle>3</Circle>
          <Circle>4</Circle>
        </CirclesWrapper>
        <Line/>
      </InfoBoxColumn>
      <InfoBoxColumn>
        <FieldWrapper>
          <Instructions>Ingresa a tu banca en línea y registra la CLABE interbancaria que aparece en la boleta. Puede demorar hasta 24 horas para que la CLABE quede registrada.</Instructions>
          <Instructions>Para garantizar tu pago, digita el número de referencia y el total a pagar tal y como aparece en tu boleta.</Instructions>
          <Instructions>Identifica como banco destino a {getDestinyBank(usePendingIncomingPayment())} y a EBANX como beneficiario.</Instructions>
          <Instructions>Confirma los datos y realiza la transferencia.</Instructions>
        </FieldWrapper>
      </InfoBoxColumn>
    </InfoBoxWrapper>
  );
}

type InformationBoxProps = {
  text: string,
  value: string,
  lastItem?: boolean,
}

export function InformationBoxArea ({text, value, lastItem = false}: InformationBoxProps): Node {
  var copy;
  const screenWidth = useScreenWidth();
  if(screenWidth < 600) {
    copy = <CopyToClipboardIcon value={value}> </CopyToClipboardIcon>;
  }
  else {
    copy = <CopySPEI copiedMessage={'COPIADO'} copyMessage={'COPIAR'} value={value}> </CopySPEI>;
  }
  if(lastItem !== true)
  {
    return (
      <Div>
        <InformationBoxWrapper>
          <FieldWrapper>
            <FieldName>{text}</FieldName>
            <FieldValue>{value} </FieldValue>
          </FieldWrapper>
          {copy}
        </InformationBoxWrapper>
        <Hr></Hr>
      </Div>
    );

  }
  return (
    <Div>
      <InformationBoxWrapper>
        <FieldWrapper>
          <FieldName>{text}</FieldName>
          <FieldValue>{value} </FieldValue>
        </FieldWrapper>
        {copy}
      </InformationBoxWrapper>
    </Div>

  );
}

export function RenderButtonArea(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const speiUrl  = getSafeSpeiUrl(incomingPayment);
  const downloadButtonMessage = 'Guardar boleta en pdf';

  return (
    <>
      <ButtonWrapper>
        <LinkButton
          inverseStyle={false}
          aria-label={downloadButtonMessage}
          type="primary"
          flat as="a"
          target="blank"
          href={`${speiUrl}&format=pdf`}
          contentDesktop={downloadButtonMessage}
          contentMobile={downloadButtonMessage}
          data-test-id="spei-pdf-button"
          onClick = { () => redirectIfCheckForConfirmationIsEnabled(incomingPayment) }/>
      </ButtonWrapper>
    </>
  );
}

type CopySPEIProps = {
  copyMessage: string,
  value: string,
  copiedMessage: string,
}
export function CopySPEI({ copyMessage, copiedMessage, value }: CopySPEIProps):Node {
  const [Clipboard, copied, handleClick] = useCopyToClipboard();
  return (
    <CopyButton
      as={Clipboard}
      onClick={handleClick}
      data-clipboard-text={value}
      copied={copied}
    >
      {copied ? copiedMessage : copyMessage}
    </CopyButton>

  );
}

const CopyButton = styled.h1`
  color: ${props => props.theme.colors.new_primary[700]};
  font-weight: bold;
  border:none!important;
  background-color: white!important;

`;

const InfoBoxWrapper = styled.div`
  border-radius: 5px;
  padding: 0px 18%;
  display: flex;
  flex-direction: row;
`;

const InfoBoxColumn = styled.div`
  position: relative;
`;

const Line = styled.div`
  z-index: 0;
  position: absolute;
  width: 2px;
  top: 32px;
  bottom: 32px;
  left: 50%;
  margin-left: -1px;
  background-color: #e3e6e9;
`;

const Circle = styled.div`
  z-index: 1;
  border-radius: 50%;
  height: 32px;
  width: 32px;

  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: bold;
  font-size: 16px;

  background-color: #e3e6e9;
`;

const CirclesWrapper = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-around;
  padding: 0 10px;
`;
const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
`;

const FieldName = styled.h1`
  font-size: 12px;
  font-weight: 300;
  font-family: OpenSans, sans-serif;
  text-align: left;
  margin: 0;
`;

const Instructions = styled.h1`
  padding: 10px;
  font-size: 12px;
  font-weight: 300;
  font-family: OpenSans, sans-serif;
  text-align: left;
  margin: 0;
`;

const InformationBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

`;

const FieldValue = styled.h1`
  font-weight: bold;
  font-family: Gilroy, sans-serif;
  font-size: 18px;
  text-align: left;
  margin: 0;
  line-height: 22px;
`;

const Hr = styled.hr`
  display: block; height: 1px;
  border: 0;
  border-top: 1px solid rgb(220,225,230);
  margin: 0.6em 0; padding: 0;
`;

const Div = styled.div`
  margin-left: 50px;
  margin-right: 50px;
  @media (max-width: 840px)
  {
    margin-left: 10px;
    margin-right: 10px;
  }
`;
